import { render, staticRenderFns } from "./AddComplaintReason.vue?vue&type=template&id=505c63ed&"
import script from "./AddComplaintReason.vue?vue&type=script&lang=js&"
export * from "./AddComplaintReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports